
import './vendor/js/featherlight.js';
import './vendor/js/featherlight.gallery.js';

$.featherlight.defaults.closeOnClick = false;
$.featherlight.defaults.loading = '<i class="fas fa-cog fa-pulse text-primary"></i> Espere...';
$.featherlight.defaults.otherClose = '.btn-close';

// Bind .ajax class to Featherlight Popup
$(document).on('click', 'a.ajax', function(e){

	var $link = $(this);
	var $href = $(this).attr('href');

	if($href.length > 1)
		$.featherlight($href, { type: 'ajax' });

	e.preventDefault();

});